import axios from "@/config/AxiosConfig";
import { io } from "socket.io-client";
import { chatroomStore, sendEmailNotification } from "@/stores/messagesStore";
import { socketConn } from "@/stores/socketConn";
import { useChatStore } from "@/stores/chatStore";
import { useLabelsStore } from "@/stores/labels";
import { useTenantStore } from "@/stores/tenant";
import { agentDetails } from "@/stores/contactsStore";
import AxiosChat from "../config/AxiosChatConfig";
import { useMessenger } from "../composables/useMessenger";
import { getAllBots } from "@/api/SettingServices";

const URL = import.meta.env.VITE_APP_API_CHAT_SERVER_URL;
const SOCKET_URL = import.meta.env.VITE_APP_API_CHAT_SERVER_SOCKET_URL;
const BOT_URL = import.meta.env.VITE_GET_BOT_JSON;

export const updateLabelsMethod = async (labelsList) => {
    const { tenantDetails } = useMessenger();
    try {
        const { uuid: tenantId } = tenantDetails;
        if (!tenantId) return console.error("tenantId required");

        const resp = await axios.post(URL + "/api/label/update-labels", {
            labelsList,
            tenantId,
        });

        if (resp.status === 200) {
            return resp?.data?.data;
        } else {
            return console.error("Unable to send message", resp);
        }
    } catch (e) {
        console.log(e);
    }
};

export const getChatLabelsMethod = async () => {
    const { tenantDetails } = useMessenger();
    const LabelsStore = useLabelsStore();
    try {
        const { uuid: tenantId } = tenantDetails;
        if (!tenantId) return console.error("tenantId required");

        const resp = await axios.get(URL + `/api/label/get-labels/${tenantId}`);

        if (resp && resp.status === 200) {
            LabelsStore.setChatLabels(resp.data?.labels);
            return resp;
        }
    } catch (e) {
        console.log(e);
    }
};

export const accessContactChat = async (email, first_name, last_name, uuid, phone) => {
    const { tenantDetails } = useMessenger();
    const { uuid: tenantId } = tenantDetails;
    if (!tenantId) return console.error("tenantId required");

    const resp = await axios.post(
        URL + `/api/user`,
        {
            email,
            firstName: first_name,
            lastName: last_name,
            uuid,
            tenantId,
            phone: `${phone}@c.us`,
            role: "Contact",
        },
        {
            headers: {
                "Content-Type": "application/json",
            },
        },
    );
    const { status, data } = resp;
    if (status === 200 && data) {
        socketConn.socket.emit("contact registerd");
        return data;
    }
};

export const addMemberToGroup = async (payload) => {
    const ChatStore = useChatStore();
    const resp = await AxiosChat.put("chat/groupadd", {
        ...payload,
    });
    // const resp = await axios.put(URL + "/api/chat/groupadd", {
    if (resp.status === 200) {
        socketConn.socket.emit("room created", resp.data.users);
        const chatIndex = ChatStore.chat_list.findIndex((chat) => chat._id === payload.chatId);
        if (chatIndex !== -1) {
            // console.log(resp.data, "resp.data");
            // [info]: not sure why we are doing this. but this remove all the current chat list. commenting it for now.
            // ChatStore.chat_list = resp.data.users;
            if (chatroomStore.chatRoom?._id === payload.chatId) {
                chatroomStore.activeChatContact = resp.data;
            }
        }
        return resp.data;
    }
};

export const renameChatGroup = async (payload) => {
    const ChatStore = useChatStore();
    const resp = await axios.put(URL + "/api/chat/rename", {
        ...payload,
    });
    if (resp.status === 200) {
        const chatIndex = ChatStore.chat_list.findIndex((chat) => chat._id === payload.chatId);
        if (chatIndex !== -1) {
            ChatStore.chat_list[chatIndex].chatName = payload.chatName;
            if (chatroomStore.chatRoom?._id === payload.chatId) {
                chatroomStore.chatRoom.chatName = payload.chatName;
                chatroomStore.activeChatContact.chatName = payload.chatName;
            }
        }
        return resp.data;
    }
};

export const removeMemberFromGroup = async (payload) => {
    const ChatStore = useChatStore();
    const resp = await AxiosChat.delete("chat/groupremove", {
        data: payload,
    });
    if (resp.status === 200) {
        socketConn.socket.emit("user removed", { ...payload });
        const chatIndex = ChatStore.chat_list.findIndex((chat) => chat._id === payload.chatId);
        if (chatIndex !== -1) {
            // [info]: commenting it for now
            // ChatStore.chat_list = resp.data.users;
            if (chatroomStore.chatRoom?._id === payload.chatId) {
                chatroomStore.activeChatContact = resp.data;
            }
        }
        return resp.data;
    }
};

export const fetchAllChats = async (filterCriteria = null) => {
    const ChatStore = useChatStore();
    const { tenantDetails, agentId } = useMessenger();

    const { uuid: tenantId } = tenantDetails;
    if (!tenantId || !agentId) return;
    let resp = {};
    if (filterCriteria) {
        resp = await axios.post(
            URL + `/api/chat/filterchats`,
            {
                userId: agentId.value,
                tenantId,
                chatStatus: chatStatus?.value || "Open",
                labelIDs: filterCriteria?.labelIDs || [],
                UUIDs: [...(filterCriteria?.contactUUIDs || []), ...(filterCriteria?.agentUUIDs || [])],
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    } else {
        resp = await axios.get(
            URL + `/api/chat/${agentId.value}/${tenantId}/${chatStatus?.value || "Open"}`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
        ChatStore.chat_list = resp.data;
    }
    if (resp.status === 200) {
        // list.value = resp.data;

        if (resp.data.length > 0 && socketConn.socket) {
            resp.data.map((chatRoom) => {
                socketConn.socket.emit("join chat", chatRoom._id);
            });
        }
        return resp.data;
    } else {
        console.error("Data NOT found", resp);
    }
};

export const accessAgent = async (agentDetails) => {
    const { tenantDetails } = useMessenger();
    const { uuid } = tenantDetails;
    const resp = await axios.post(
        URL + `/api/user`,
        { ...agentDetails, role: "Agent", tenantId: uuid },
        {
            headers: {
                "Content-Type": "application/json",
            },
        },
    );

    const { status, data } = resp;
    if (status === 200 && data) {
        return resp.data._id;
    } else {
        return null;
    }
};

export const getChatsByContactUuid = async (contactUUID) => {
    const { tenantDetails } = useMessenger();
    const { uuid } = tenantDetails;
    try {
        const resp = await axios.get(URL + `/api/chat/getChatsByContactUuid`, {
            params: { contactId: contactUUID, tenantId: uuid },
        });
        if (resp.status === 200) {
            return resp.data;
        }
    } catch (e) {
        console.error(e);
    }
};

export const getAgentId = async () => {
    const { authUser } = JSON.parse(localStorage.getItem("authStore"));

    const userDetails = {
        email: authUser?.email,
        firstName: authUser?.first_name,
        lastName: authUser?.surname,
        userName: authUser?.user_name,
        uuid: authUser?.uuid,
    };
    const agentID = await accessAgent(userDetails);
    agentDetails.agentId = agentID;
    return agentID;
};

export const getAllRoomMessages = async ({ chatRoomId, pageSize, pageSkip }) => {
    // const roomId = chatroomStore.chatRoom._id;
    const tenantStore = useTenantStore();
    const tenantDetails = tenantStore.getTenant;
    const roomId = chatRoomId;

    const agentId = agentDetails.agentId;
    if (!roomId || !agentId) return;
    try {
        const resp = await axios.get(
            URL + `/api/message/${roomId}/${agentId}?pageSize=${pageSize}&pageSkip=${pageSkip}`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
        if (resp.status === 200) {
            if (resp.data.length > 0) {
                const reversedList = resp.data.reverse();
                reversedList.map((item) => item.docs.reverse());
                chatroomStore.message[roomId] = reversedList;
                chatroomStore.messages = reversedList;
                chatroomStore.activeChatContact = resp.data[0]?.docs[0].chat;
            } else {
                chatroomStore.message[roomId] = resp.data;
                chatroomStore.messages = resp.data;
                chatroomStore.activeChatContact = resp.data[0]?.docs[0].chat;
            }

            //Send Email if it's a first message in the room
            if (resp?.data[0]?.docs?.length === 1 && sendEmailNotification.isSend === true) {
                sendEmailNotification.isSend = false;
                const { client_portal_url } = tenantDetails;
                const latestMessage = resp?.data[0]?.docs[resp?.data[0]?.docs?.length - 1];
                /*
            const response = await axios.post(
                URL + `/send-email-notification`,
                {
                    message: latestMessage?.content,
                    senderEmail: latestMessage?.sender?.email,
                    chat: chatroomStore.chatRoom,
                    agency: client_portal_url,
                },
                {
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            );
            */
                const wpRes = await axios.post(
                    URL + `/send-wp-notification`,
                    {
                        message: latestMessage?.content,
                        senderSession: latestMessage?.sender?.wpSession,
                        chat: chatroomStore.chatRoom,
                        messageId: latestMessage?._id,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    },
                );
            }
            return resp.data;
        } else {
            console.error("Data NOT found", resp);
        }
    } catch (e) {
        console.error(e);
    }
};

let timerInstance = null;
export const getKeyEvents = async (_ev) => {
    if (!socketConn.socket) {
        console.error("Socket connection not established");
        return;
    }

    if (timerInstance) {
        clearTimeout(timerInstance);
    }
    socketConn.socket.emit("typing", chatroomStore.chatRoom._id);
    timerInstance = setTimeout(() => {
        socketConn.socket.emit("stop typing", chatroomStore.chatRoom._id);
    }, 1000);

    if (_ev.keyCode === 13) {
        sendMessage();
    }
};

const updateUserStatus = async (status) => {
    const resp = await axios.put(
        URL + `/api/user/updateUser`,
        {
            status,
            userId: agentDetails.agentId,
        },
        {
            headers: {
                "Content-Type": "application/json",
            },
        },
    );

    if (resp.status >= 400) {
        console.error("Data NOT found", resp);
    }
};

export const establishSocketConn = async () => {
    agentDetails.agentId ?? (await getAgentId());

    if (!socketConn.socket) {
        socketConn.socket = io(SOCKET_URL);
    }
    if (socketConn.socket?.connected) return;
    socketConn.socket.on("connect", () => {
        updateUserStatus("Online");
        socketConn.socket.emit("setup", agentDetails.agentId);
    });
};

export const disconnectSocket = () => {
    socketConn.socket.emit("close", agentDetails.agentId);
};

export const sendMessage = async ({ isNote, chatRoomId, content }) => {
    const tenantStore = useTenantStore();
    const tenantDetails = tenantStore.getTenant;
    if (content.trim() === "" && !isNote) return console.error("Empty input value");
    socketConn.socket.emit("stop typing", agentDetails.agentId);

    const roomId = chatRoomId;
    const agentId = agentDetails.agentId;

    if (!roomId || !agentId) return console.error("roomId && agentId required");

    const { uuid: tenantId } = tenantDetails;

    try {
        const resp = await axios.post(
            URL + `/api/message`,
            {
                content: content || "a",
                chatId: roomId,
                contentType: isNote ? "note" : "text",
                note: isNote ? "" : "",
                userId: agentId,
                sentFrom: "Inbox",
                tenantId,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
        if (resp.status === 200) {
            // note = null;
            const chatRoomInfo = resp.data.data;
            socketConn.socket.emit("new message", chatRoomInfo);
            chatroomStore.chatRoom = chatRoomInfo?.chat;
            // messageStatus.isSend = true;
            sendEmailNotification.isSend = true;
            // content = "";
            if (resp?.data?.notificationMessage === "You need to assign contacts to get notifications.") {
                const isRequested = prompt(resp?.data?.notificationMessage, 'Type "yes"');

                if (isRequested.toLowerCase() === "yes") {
                    assignToRoom(false);
                }
            } else {
                validateAssignment();
            }
            return resp;
        } else {
            console.error("Unable to send message", resp);
        }
    } catch (error) {
        console.error("Unable to send message", error.response);
    }
};

export const validateAssignment = () => {
    const { users } = chatroomStore.chatRoom;
    const agentIds = users.filter((item) => item.role === "Agent").map((item) => item._id);

    const isAgentAssigned = agentIds.includes(agentDetails.agentId);
    if (isAgentAssigned) return;
    assignToRoom(true);
};

export const assignToRoom = async (flag) => {
    const tenantStore = useTenantStore();
    const tenantDetails = tenantStore.getTenant;
    const { uuid: tenantId } = tenantDetails;
    const { _id: chatId } = chatroomStore.chatRoom;
    try {
        const resp = await axios.post(
            URL + `/api/chat/assign-chatroom`,
            {
                userId: agentDetails.agentId,
                chatId,
                tenantId,
                flag,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        if (resp.status === 200) {
            // messageStatus.isSend = true;
        } else {
            console.error("Unable to assign contacts to the Agent", resp);
        }
    } catch (error) {
        console.error("Unable to assign contacts to the Agent", error.response);
    }
};

export const getChatbyId = async (chatId) => {
    const { tenantDetails } = useMessenger();
    const { uuid } = tenantDetails;
    try {
        const resp = await axios.get(URL + `/api/chat/getChatById`, {
            params: { chatId, tenantId: uuid },
        });
        if (resp.status === 200) {
            return resp.data;
        }
    } catch (e) {
        console.error(e);
    }
};

export const getBots = async () => {
    const botsJson = await getAllBots();
    const bot = botsJson.data.orphan_bots.active;
    return [
        {
            heading: true,
            id: 0,
            subnav: [],
            title: "SEND BOTS",
        },
        ...(bot.length > 0 &&
            bot.map((bot) => ({
                icon: "message-bot",
                id: bot.id,
                subnav: [],
                title: bot.name,
            }))),
    ];
};
export const getBotJson = async (selectedBotId = null) => {
    const { tenantDetails } = useMessenger();
    const { uuid: tenantId } = tenantDetails;
    if (!tenantId) return console.error("tenantId required");
    const resp = await axios.post(BOT_URL, {
        botId: selectedBotId,
        tenant_uuid: tenantId,
    });
    if (resp.status === 200) {
        return resp?.data?.data;
    } else {
        return console.error("Unable to send message", resp);
    }
};
let enterButtonClicked;
export const sendBotMessage = async (selectedBotId = null, chatRoomId = null, chatAgentId = null) => {
    socketConn.socket.emit("stop typing", chatroomStore.chatRoom.users);
    const finalRoomId = chatRoomId || chatroomStore.activeChatContact._id;
    const finalAgentId = chatAgentId || agentDetails.agentId;
    if (!finalRoomId || !finalAgentId) return console.error("roomId && agentId required");
    try {
        let botJson = null;
        if (selectedBotId) {
            botJson = await getBotJson(selectedBotId);
        } else {
            return console.error("BOT id is required");
        }
        const resp = await axios.post(
            URL + `/chat-bot-webhook`,
            {
                chatroomId: finalRoomId,
                fromUserId: finalAgentId,
                botData: botJson,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
        enterButtonClicked = 0;
        if (resp.status === 200) {
            const chatRoomInfo = resp.data.data;
            socketConn.socket.emit("new message", chatRoomInfo);
            chatroomStore.chatRoom = chatRoomInfo?.chat;
            // messageStatus.isSend = true;
            sendEmailNotification.isSend = true;
            // messageInput.value = "";
            if (resp?.data?.notificationMessage === "You need to assign contacts to get notifications.") {
                const isRequested = prompt(resp?.data?.notificationMessage, 'Type "yes"');
                if (isRequested.toLowerCase() === "yes") {
                    assignToRoom(false);
                }
            } else {
                validateAssignment();
            }
        } else {
            console.error("Unable to send message", resp);
        }
    } catch (error) {
        console.error("Unable to send message", error.response);
    }
};
export const sendFile = async (event, note = null) => {
    const { tenantDetails } = useMessenger();
    const files = event.target.files;
    let contentType = null;
    const { uuid: tenantId } = tenantDetails;
    Object.values(files).map((file) => {
        if (file.type.includes("image")) contentType = "image";
        if (
            file.type.includes("pdf") ||
            file.type.includes("excel") ||
            file.type.includes("spreadsheet") ||
            file.type.includes("msword") ||
            file.type.includes("document") ||
            file.type.includes("powerpoint") ||
            file.type.includes("presentation")
        )
            contentType = "document";
        if (file.type.includes("video")) contentType = "video";
        if (file.type.includes("audio")) contentType = "audio";
    });
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
        formData.append("content", files[i]);
        formData.append("mimeType", files[i]?.type);
    }
    formData.append("chatId", chatroomStore.activeChatContact._id);
    formData.append("contentType", contentType);
    formData.append("userId", agentDetails.agentId);
    formData.append("note", note);
    formData.append("sentFrom", "Inbox");
    formData.append("tenantId", tenantId);
    if (!chatroomStore?.activeChatContact?._id || !agentDetails?.agentId)
        return console.error("roomId && agentId required");
    const resp = await axios.post(URL + `/api/message`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    if (resp.status === 200) {
        const chatRoomInfo = resp.data.data;
        socketConn.socket.emit("new message", chatRoomInfo);
        chatroomStore.chatRoom = chatRoomInfo?.chat;
        // messageStatus.isSend = true;
        // messageInput.value = "";
        if (resp?.data?.notificationMessage === "You need to assign contacts to get notifications.") {
            const isRequested = prompt(resp?.data?.notificationMessage);
            if (isRequested.toLowerCase() === "yes") {
                assignToRoom(false);
            }
        } else {
            validateAssignment();
        }
    } else {
        console.error("Unable to send message", resp);
    }
};


const messageHandler = {
    async handleNewMessage(newMessageReceived) {
        if (!this.validateMessage(newMessageReceived)) {
            return;
        }

        await this.updateChatMessages(newMessageReceived.chat._id);
        if (!newMessageReceived.chat.bot_id) return;
        console.log('yes.')
        await this.handleBotMessage(newMessageReceived);
    },

    validateMessage(message) {
        if (!message || !message.chat || !message.chat._id) {
            console.warn("Invalid message data received:", message);
            return false;
        }
        return true;
    },

    async updateChatMessages(chatId) {
        try {
            await getAllRoomMessages({
                chatRoomId: chatId,
            });
        } catch (error) {
            console.error("Failed to fetch room messages:", error);
        }
    },

    async handleBotMessage(message) {
        if (!message.chat.bot_id || message.sentFrom !== "Widget") {
            return;
        }

        try {
            const { bot_id, _id } = message.chat;
            const agentId = message.chat.users?.find((user) => user.role === "Agent")?._id;

            if (bot_id && _id && agentId) {
                await sendBotMessage(bot_id, _id, agentId);
            } else {
                console.warn("Missing required data for bot message:", message.chat);
            }
        } catch (error) {
            console.error("Error handling bot message:", error);
        }
    },
};

export const messageQueue = {
    queue: [],
    processing: false,

    async add(message) {
        this.queue.push(message);
        if (!this.processing) {
            setTimeout(async () => {
                await this.process();
            }, 0);
        }
    },

    async process() {
        if (this.processing || this.queue.length === 0) {
            return;
        }

        this.processing = true;
        try {
            const batchSize = 10;
            let processed = 0;

            while (this.queue.length > 0 && processed < batchSize) {
                const message = this.queue.shift();
                await messageHandler.handleNewMessage(message);
                processed++;
            }

            if (this.queue.length > 0) {
                setTimeout(async () => {
                    await this.process();
                }, 100);
            }
        } catch (error) {
            console.error("Error processing message queue:", error);
        } finally {
            this.processing = false;
        }
    },
};